module.exports = __webpack_public_path__ + "static/media/andre_gooden.5be89a6e.pdf";